<template>
    <div class="modal-background">
        <div class="coupon-container in" >
            <div class="coupon-close" @click.stop="closeLogin">
                <button class="c-button c-button--rounded c-button--close">
                    <i class="iconfont">&#xe615;</i>
                </button>
            </div>
            <div class="header">领取优惠券</div>
            <div class="coupon-box" v-if="coupnList.length" :style="{ opacity: coupnList.length ? 1 : 0, transition: 'opacity .1s', }">
                <div class="coupon-ul">
                    <div class="coupon-li" v-for="(item, index) in coupnList" :key="index">
                        <!-- 商品券 -->
                        <template v-if="item.coupon_type == 'product_coupon'">
                            <div class="top">
                                <div class="li_type">
                                    <div class="txt shop">
                                        <img class="img" :src="item.coupon_pic" />
                                    </div>
                                </div>
                                <div class="li_msg">
                                    <div class="name">{{ item.product_coupon_name }}</div>
                                    <div class="time" v-if="item.expire_days">领取后{{ item.expire_days }}天内可用</div>
                                    <!-- <span class="time" v-else="">{{ m.toDateString(item.start) }} - {{ m.toDateString(item.end) }}</span> -->
                                </div>
                            </div>
                        </template>
                        <!-- 折扣券 -->
                        <template v-else-if="item.coupon_type == 'coupon_discount'">
                            <div class="top">
                                <div class="li_type">
                                    <div class="txt">
                                        <span class="num">{{ item.product_discount }}折</span>
                                    </div>
                                </div>
                                <div class="li_msg">
                                    <div class="name">{{ item.desc }}</div>
                                    <div class="time" v-if="item.expire_days">领取后{{ item.expire_days }}天内可用</div>
                                    <!-- <span class="time" v-else="">{{ m.toDateString(item.start) }} - {{ m.toDateString(item.end) }}</span> -->
                                </div>
                            </div>
                        </template>
                        <!-- 满减券 -->
                        <template v-else>
                            <div class="top">
                                <div class="li_type">
                                    <div class="txt">
                                        <span class="tag">￥</span>
                                        <span class="num">{{ item.price }}</span>
                                    </div>
                                </div>
                                <div class="li_msg">
                                    <div class="name">{{ item.desc }}</div>
                                    <div class="desc">满{{ item.require || '' }}可用</div>
                                    <div class="time" v-if="item.expire_days">领取后{{ item.expire_days }}天内可用</div>
                                    <!-- <span class="time" v-else>{{ m.toDateString(item.start) }} - {{ m.toDateString(item.end) }}</span> -->
                                </div>
                            </div>
                        </template>
                        <div class="bottom" v-if="item.is_get === 1">已领取</div>
                        <div class="bottom" v-else  @click="handleSendCoupon(item, index)">立即领取</div>
                    </div>
                </div>
            </div>
            <div v-else class="warn">暂无可领取电子礼券</div>
        </div>
    </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";

export default {
    name: 'ReceiveCoupons',
    props: {
        unique_id: {
            type: String,
            required: true,
        },
        cats: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            coupnList: []
        }
    },
    created() {
        console.log(this.unique_id)
        if (this.unique_id) {
            this.devPageSource();
        }
    },
    methods: {
        closeLogin() {
            this.$emit('onClose');
        },
        devPageSource() {
            const { unique_id, cats } = this;
            api[types.PDP_USER_COUPONS]({
                unique_id: unique_id,
                cats: cats.join(',')
            }).then(res => {
                const { code, data } = res;
                if (code == 1) {
                    this.coupnList = data;
                }
            })
        },
        handleSendCoupon(item) {
            if (this.isSend) return;
            this.isSend = true;
            const { id } = item;
            api[types.GET_COUPON]({
                coupon_id: id,
                user_id: this.$store.state?.userInfo?.id,
            }).then(res => {
                this.$toast({ message: res.message, iconCls: "success" });
                this.isSend = false;
                item.is_get = 1;
            }).catch(() => {
                this.isSend = false;
            })
        },
    }
}

</script>

<style lang="scss" scoped>
.coupon-container {
    position: fixed;
    right: -100%;
    opacity: 0;
    background-color: #fff;
    z-index: 12;
    width: 100%;
    transition-property: opacity, right;
    transition-duration: 1.5s, 1s;
    bottom: 0;
    padding-top: 40px;
    
    .warn {
        padding: 100px 0;
        text-align: center;
    }

    &.in {
        position: fixed;
        right: 0;
        opacity: 1;
        transition-property: opacity, right;
        transition-duration: 2s, 1.5s;
    }

    .coupon-close {
        position: absolute;
        right: 18px;
        top: 18px;

        .c-button--rounded {
            width: 28px;
            height: 28px;
        }
    }

    .header {
        font-size: 16px;
        padding-bottom: 16px;
        font-weight: 500;
        padding-left: 16px;
    }

    .coupon-box {
        padding: 0 16px 40px;
        max-height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;



        .coupon-ul {
            .coupon-li {
                margin-bottom: 16px;
                position: relative;
                overflow: hidden;

                &:active {
                    opacity: 0.6;
                }

                .top {
                    min-height: 80px;
                    border: 1px solid #d9d9d9;
                    border-bottom: unset;
                    border-radius: 15px 15px 0 0;
                    padding: 12px 12px 12px 0;
                    display: flex;
                    align-items: center;

                    .li_type {
                        width: 146px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        .txt {
                            display: flex;
                            align-items: flex-end;

                            &.shop {
                                width: 104px;
                                height: 50px;
                                padding: 0 6px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                .img {
                                    max-width: 100%;
                                    max-height: 100%;
                                }
                            }

                            .tag {
                                font-size: 24px;
                                margin-right: -4px;
                                line-height: 24px;
                            }

                            .num {
                                font-size: 24px;
                                font-weight: 600;
                                line-height: 24px;
                            }
                        }
                    }

                    .li_msg {
                        flex: 1;

                        .name {
                            font-size: 14px;
                            font-weight: 500;
                        }

                        .desc {
                            font-size: 12px;
                            color: #666;
                        }

                        .time {
                            font-size: 12px;
                            color: #666;
                        }
                    }
                }

                .bottom {
                    height: 35px;
                    border: 1px solid #d9d9d9;
                    border-top: 1px dashed #d9d9d9;
                    position: relative;
                    border-radius: 0 0 15px 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    &::before,
                    &::after {
                        content: "";
                        width: 15px;
                        height: 15px;
                        background: #fff;
                        border: 1px solid #d9d9d9;
                        position: absolute;
                        left: -7.5px;
                        top: -7.5px;
                        z-index: 2;
                        border-radius: 50%;
                    }

                    &::after {
                        left: unset;
                        right: -7.5px;
                    }
                }
            }
        }
    }
}

@media screen and (min-width: 48em) {
    .coupon-container {
        right: -100%;
        opacity: 0;
        background-color: #fff;
        z-index: 12;
        width: 571px;
        transition-property: opacity, right;
        transition-duration: 1.5s, 1s;
        bottom: 0;
        padding: 151px 90px 90px;
        top: 0;
        height: 100vh;
        overflow-y: auto;

        &.in {
            right: 0;
            opacity: 1;
            transition-property: opacity, right;
            transition-duration: 2s, 1.5s;
        }

        .coupon-close {
            right: 90px;
            top: 151px;

            .c-button--rounded {
                width: 38px;
                height: 38px;
            }
        }

        .header {
            padding-top: 62px;
            font-size: 24px;
            padding-bottom: 40px;
        }

        .coupon-box {
            padding: 0;
            max-height: unset;
        }
    }
}
</style>